import { FEATURE_FLAGS } from '~/constants/featureFlags';
import { shouldStayOnNuxtTwo, toMigrationPath } from '~/helpers/migrationPath';

export default function ({ store, route, redirect, $authService, $config }) {
  const baseUrl = $config.plannrMigrationURL;

  if (!baseUrl || baseUrl.endsWith('_PLACEHOLDER')) return;
  if (!$authService.loggedIn || store.getters['user/isPortalUser']) return;
  const migratedUserUuids = ($config.plannrMigrationUserUuids || '')
    .split(',')
    .map((uuid) => uuid.trim())
    .filter(Boolean);
  const shouldRedirectFirm = store.getters['user/allEnabledFeatures'].includes(FEATURE_FLAGS.NUXT_FOUR);
  const shouldRedirectUser = migratedUserUuids.includes(store.state.user.user?.uuid);

  if (!shouldRedirectFirm && !shouldRedirectUser) return;
  if (shouldStayOnNuxtTwo(route.path)) return;

  const query = new URLSearchParams();
  Object.entries(route.query).forEach(([key, value]) => {
    [].concat(value).forEach((item) => query.append(key, item ?? ''));
  });

  const queryString = query.toString();

  return redirect(`${baseUrl}${toMigrationPath(route.path)}${queryString ? `?${queryString}` : ''}${route.hash}`);
}
